import { Button, Text, VStack } from '@chakra-ui/react'
import { useAuth, useValidateUserStep } from 'context'
import { themeColors } from 'theme'

import { CheckmarkIcon } from 'components/SVGS'

export const StepTwo = () => {
  const { icon: { successIconColor } } = themeColors
  const {
    validateUserState: {
      state: {
        userValidation: { email, password },
      },
    },
  } = useValidateUserStep()

  const { login, authState: { loading } } = useAuth()

  const handleOnPress = async () => await login({ email, password })

  return (
    <VStack w={'full'} maxW={'330px'} spacing={'32px'}>
      <CheckmarkIcon size={100} fill={successIconColor} />
      <Text variant={'TXT_L'} textAlign={'center'}>
        ¡Felicitaciones!
      </Text>
      <Text variant={'SM'}>
        Tu cuenta ha sido creada con éxito, te damos la bienvenida a WiCar
      </Text>
      <Button
        w={'full'}
        isLoading={loading}
        disabled={loading}
        loadingText="Iniciando sesión..."
        onClick={handleOnPress}>
        Entendido
      </Button>
    </VStack>
  )
}
